import { callAPi, callAPiMultiPart } from "./api";

const create = (data) => callAPiMultiPart.post("/admin/announcements", data);
const edit = (data, id) =>
  callAPiMultiPart.patch(`/admin/announcements/${id}`, data);
const get = () => callAPi.get("/announcements");
const getByID = (id) => callAPi.get(`/announcements/${id}`);
const getArchived = () => callAPi.get("/admin/announcements/archived");
const archiveAnnouncement = (id) =>
  callAPi.patch(`/admin/announcements/${id}/archive`);
const restoreAnnouncement = (id) =>
  callAPi.patch(`/admin/announcements/${id}/restore`);

const deleteAnnouncement = (id) => callAPi.delete(`/admin/announcements/${id}`);

const announcementServices = {
  create,
  edit,
  get,
  getArchived,
  archiveAnnouncement,
  restoreAnnouncement,
  deleteAnnouncement,
  getByID,
};

export default announcementServices;
